import { TabbedContent } from '@verndale/front-end-components';

class Module extends TabbedContent {
  setupDefaults() {
    const identifier = this.el.dataset.identifier;
    this.dom = {
      $tabs: this.el._$$(`[data-identifier="${identifier}"][role="tab"]`),
      $panels: this.el._$$(`[data-identifier="${identifier}"][role="tabpanel"]`),
      $dropdown: this.el._$('.tabbed-content__dropdown')
    };
    this.isVertical = this.el.dataset.isVertical === 'true';
  }

  addListeners() {
    this.dom.$tabs.forEach(tab => tab._on('click', this.onClick.bind(this)));
    this.dom.$tabs.forEach(tab => tab._on('keydown', this.onKeyDown.bind(this)));
    this.dom.$tabs.forEach(tab => tab._on('keyup', this.onKeyUp.bind(this)));
    this.el._on('activatetab', this.onActivatetab.bind(this));
    this.el._on('reset', this.onReset.bind(this));
    this.el._on('click', this.handleElementClick.bind(this));
  }

  handleElementClick(e) {
    const isTabButton = e.target.classList.toString().includes('tabbed-content__tab btn');
    if (!isTabButton) return;
    window.dispatchEvent(new Event('clickontab'));
  }

  constructor(el) {
    super(el);
  }
}

export default Module;
